import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQuery } from '@services/baseQuery';
import { handleError } from '../../utils/api-error-handling';
import { encryptPayload } from '@utils/security';
import {
  IValidateNetLockPayload,
  IValidateNetlockResponse,
} from '@modules/accounting-and-finance/interface/accg-general.interface';

export const netLockApi = createApi({
  reducerPath: 'netLockApi',
  baseQuery: baseQuery,
  tagTypes: ['Netlock'],
  endpoints: (builder) => ({
    deleteNetLock: builder.mutation({
      query: (payload) => ({
        url: `netlock/${payload}`,
        method: 'DELETE',
      }),
      transformErrorResponse: async (baseQueryReturnValue: any) => {
        return handleError(baseQueryReturnValue);
      },
    }),
    validateNetLock: builder.mutation({
      query: (payload: IValidateNetLockPayload) => ({
        url: `netlock`,
        method: 'POST',
        body: encryptPayload(payload),
      }),
      transformResponse: async (response: IValidateNetlockResponse) => {
        return response?.data;
      },
      transformErrorResponse: async (baseQueryReturnValue: any) => {
        return handleError(baseQueryReturnValue);
      },
    }),
  }),
});

export const { useDeleteNetLockMutation, useValidateNetLockMutation } =
  netLockApi;
